module.exports = __webpack_public_path__ + "static/media/icon_location_network.5af322b3.png";